export const requestDataEmpresa = (datos) =>  {
    return {
        nombre: datos.nombre,
        usuario: datos.usuario,
        password: datos.password,
        moduloGeocercas: datos.moduloGeocercas ?? true,
        moduloPausas: datos.moduloPausas ?? false,
        moduloCinturones: datos.moduloCinturones ?? false,
    }
}
